//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import report from '~/graphql/queries/report';
import reports from '~/graphql/queries/reports';
import {STATUSSES} from '~/plugins/constants';
import upsertReport from '~/graphql/mutations/upsertReport.gql';
import sendReport from '~/graphql/mutations/sendReport.gql';
import deleteReport from '~/graphql/mutations/deleteReport.gql';
import addReportImages from '~/graphql/mutations/addReportImages';

export default {
  props: {
    reportSpecies: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    loaded: false,
    report: {},
    savedReport: {},
    speciesSearch: '',
    speciesType: '',
    changes: false,
    showProblems: false,
    showComments: false,
    showDetailsModal: false,
    showSendingModal: false,
    isSent: false,
  }),
  computed: {
    tags() {
      return [
        {
          faType: 'fas',
          icon: 'calendar',
          value: this.$dateFns.format(this.report.date ? this.report.date : this.report.created_at, 'dd/MM/yyyy'),
        },
        {
          faType: 'fas',
          icon: 'clock',
          value: this.report.time ? this.report.time : this.$dateFns.format(this.report.created_at, 'HH:mm'),
        },
        {
          faType: 'fas',
          icon: this.thermometerIcon,
          value: this.report.temperature + '°C',
        },
        {
          faType: this.weatherIcon.faType ? this.weatherIcon.faType : 'fas',
          icon: this.weatherIcon.icon,
          value: this.report.weather,
        },
      ];
    },
    weatherIcon() {
      const icons = {
        Zonnig: {icon: 'sun'},
        'Half bewolkt': {icon: 'cloud-sun'},
        Bewolkt: {icon: 'cloud'},
        Droog: {faType: 'far', icon: 'cactus'},
        Regen: {icon: 'cloud-rain'},
      };
      return this.report.weather ? icons[this.report.weather] : icons.Bewolkt;
    },
    thermometerIcon() {
      if (this.report.temperature > 22) {
        return 'thermometer-full';
      }
      if (this.report.temperature > 5) {
        return 'thermometer-half';
      }
      return 'thermometer-empty';
    },
  },
  watch: {
    report: {
      handler() {
        this.checkChanges();
      },
      deep: true,
    },
  },
  mounted() {
    this.getReport();
  },
  methods: {
    getReport(noCache) {
      this.$apollo.query({
        query: report,
        variables: {
          uuid: this.$route.params.uuid,
        },
        ...(noCache ? {fetchPolicy: 'no-cache'} : {}),
      }).then((data) => {
        this.report = JSON.parse(JSON.stringify(data.data.report));
        if (!this.report.date) {
          this.report.date = this.report.created_at;
        }
        this.savedReport = JSON.parse(JSON.stringify(data.data.report));
        this.isSent = this.report.status === 'sent';
        this.$emit('setIsSent', this.isSent);
        this.loaded = true;
      });
    },
    editComments() {
      this.showComments = true;
      this.$refs['comments-modal'].editing = true;
    },
    editProblems() {
      this.showProblems = true;
      this.$refs['problems-modal'].editing = true;
    },
    setComments(value) {
      this.showComments = false;
      this.report.comments = value;
    },
    setProblems(value) {
      this.showProblems = false;
      this.report.problems = value;
    },
    getStatus(status) {
      return STATUSSES[status] ? STATUSSES[status] : 'Onbekend';
    },
    maxLength(string, length) {
      if (!string) {
        return '';
      }
      if (string.length > length + 5) {
        return string.substring(0, length) + '...';
      }
      return string;
    },
    saveDetails() {
      this.showDetailsModal = false;
      this.changes = false;
      this.saveReport();
    },
    checkChanges() {
      const compareFields = ['title', 'content', 'problems', 'comments', 'temperature', 'weather', 'general_impression', 'herbs_to_grass_percentage', 'degree_of_entry'];
      let changes = false;
      compareFields.forEach((field) => {
        if (this.savedReport[field] !== this.report[field]) {
          changes = true;
        }
      });
      return this.changes = changes;
    },
    async saveReport() {
      if (this.report.title.length < 3) {
        this.$toast.error('Rapportage titel moet minimaal 3 karakters lang zijn.');
        return;
      }
      try {
        await this.$apollo.mutate({
          mutation: upsertReport,
          variables: this.parseReport(this.report),
        }).then((data) => {
          if (data) {
            this.$toast.success('De rapportage is opgeslagen.');
            this.savedReport = JSON.parse(JSON.stringify(this.report));
            this.changes = false;
          } else {
            this.$toast.error('Er is iets fout gegaan met opslaan van de rapportage');
          }
        });
      } catch (e) {
        this.$toast.error(e);
      }
    },
    parseReport(report) {
      const newReport = JSON.parse(JSON.stringify(report));
      newReport.project = report.project.uuid;
      newReport.location = report.location.uuid;
      newReport.temperature = parseInt(report.temperature);
      return newReport;
    },
    async deleteReport() {
      try {
        if (!confirm('Weet je zeker dat je dit rapport wil verwijderen?')) {
          return;
        }

        await this.$apollo.mutate({
          mutation: deleteReport,
          variables: {
            uuid: this.$route.params.uuid,
          },
          refetchQueries: [{
            query: reports,
          }],
        });

        await this.$router.push(this.localeRoute({name: 'rapportages'}));
        this.$toast.success('Het rapport is verwijderd.');
      } catch (e) {
        this.$toast.error(e);
      }
    },
    startSending() {
      if (this.report.title.length < 3) {
        this.$toast.error('Rapportage titel moet minimaal 3 karakters lang zijn.');
        return;
      }
      this.showSendingModal = true;
    },
    async sendReport(message) {
      this.showSendingModal = false;
      if (this.changes) {
        await this.saveReport();
      }
      try {
        await this.$apollo.mutate({
          mutation: sendReport,
          variables: {
            uuid: this.$route.params.uuid,
            message,
          },
        }).then((data) => {
          if (data) {
            this.report.status = 'sent';
            this.isSent = true;
            this.$emit('setIsSent', this.isSent);
            this.$toast.success('De rapportage is verstuurd.');
            this.getReport(true);
          } else {
            this.$toast.error('Er is iets fout gegaan met het versturen van de rapportage');
          }
        });
      } catch (e) {
        this.$toast.error(e);
      }
    },
    async uploadImages(event) {
      const files = Array.from(event.target.files);
      try {
        await files.forEach(async (file) => {
          const tempId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

          this.report.images.push({
            id: null,
            name: file.name,
            url: URL.createObjectURL(file),
            tempId,
          });

          const {data} = await this.$apollo.mutate({
            mutation: addReportImages,
            variables: {
              uuid: this.$route.params.uuid,
              images: [file],
            },
            context: {
              hasUpload: true,
            },
          });

          this.removeTempImage(tempId);
          data.addReportImages.images.forEach((image) => {
            if (!this.report.images.find(i => i.id === image.id)) {
              image.title = image.name;
              this.report.images.push(image);
            }
          });
        }, Error('Image upload failed'));
      } catch (e) {
        this.$toast.error(e);
      }
    },
    removeTempImage(tempId) {
      const removeIndex = this.report.images.map(function (item) {
        return item.tempId;
      }).indexOf(tempId);
      this.report.images.splice(removeIndex, 1);
    },
  },
};
